import React from "react";
import { PropTypes } from "prop-types";

function OkastIcon({ className }) {
  return (
    <svg
      className={className}
      id="Layer_1"
      x="0px"
      y="0px"
      viewBox="0 0 158.6 149.7"
      style={{ enableBackground: "new 0 0 158.6 149.7" }}
    >
      <defs id="defs21" />
      <g id="g16">
        <g id="g14">
          <path
            className="st0"
            d="M158.6,76.7c-0.9,17-5,32.8-15.8,46.3c-11.4,14.1-26.6,21.7-44.1,24.8c-21.4,3.9-42.3,2.3-62-7.7    c-19.9-10.1-31-26.8-35.1-48.4C-1,77.9-0.5,64.2,3.6,50.7c6.7-22.1,21.1-37.3,42.8-44.8c26-9,51.7-8,76.3,4.7    c19.5,10.1,30.2,26.9,34,48.2C157.8,64.7,158,70.7,158.6,76.7z M77.3,34.1c-2.3,0.4-6.9,0.6-11.1,2.1c-16.7,5.7-25,18.1-26.3,35.2    c-1.2,15.5,3.3,29.2,16.9,38c13.4,8.7,27.9,8.9,42,1.7c13.2-6.7,18.7-18.7,19.6-32.9C119.8,54.9,107.5,34.7,77.3,34.1z"
            id="path12"
          />
        </g>
      </g>
      <path
        style={{ fill: "#888888", strokeWidth: 0.617852, fillOpacity: 1 }}
        d="M 69.016198,149.05097 C 52.649887,147.51377 35.159528,140.57686 23.875549,131.14759 15.640727,124.2663 8.1300816,112.92235 4.6633543,102.12982 1.6703573,92.8121 0.69877839,86.266878 0.67377046,75.253256 0.65384053,66.476025 0.88513012,63.691798 2.0810623,58.312507 8.1108386,31.190618 23.077386,14.155954 48.204684,5.815405 c 25.75983,-8.5505068 48.890575,-7.1825395 72.288696,4.2752 21.64332,10.598438 33.43916,28.320591 36.79231,55.277018 3.41978,27.491978 -6.53725,53.547467 -26.09471,68.284447 -7.55478,5.69271 -16.61625,9.95059 -26.76175,12.57506 -9.620586,2.48867 -25.500083,3.75491 -35.413032,2.82384 z M 89.002707,115.09966 C 103.78883,111.318 113.42739,102.0877 117.19148,88.104877 c 1.7127,-6.362345 1.86051,-18.850334 0.29839,-25.208663 C 114.76336,51.798545 107.98972,43.141312 98.480681,38.601021 74.344011,27.07645 47.248105,38.237096 41.111482,62.231066 c -4.495116,17.57573 0.0157,35.07356 11.45824,44.447484 4.164621,3.41173 12.403549,7.63016 17.150278,8.78114 5.058478,1.22658 13.710756,1.06503 19.282707,-0.36003 z"
        id="path25"
      />
    </svg>
  );
}

OkastIcon.propTypes = {
  className: PropTypes.string,
};

export default OkastIcon;
